const Avatar = {
	MuiAvatar: {
		styleOverrides: {
			root: {
				height: 68,
				width: 68,
			},
		},
	},
}

export default Avatar
